import { useEffect, useState, createRef } from "react";
import { disableMapEvents } from "../utils/mapFunctions";
import MapConfig from "../utils/map-config.json";
import { getDatasetsJson } from "../utils/DatasetsJson";

const FilterControl = (props) => {
  const DatasetsJson = getDatasetsJson();
  const panelRef = createRef();
  const [selectedFilters, setSelectedFilters] = useState(props.filters);

  useEffect(() => {
    disableMapEvents(panelRef);
  }, [panelRef]);

  const getFilters = () => {
    const result = MapConfig.Filters.map(({ labels, level, filter, ...rest }) => ({
      ...rest,
      filter,
      options: countFilters(DatasetsJson, filter, level)
    }));
    return result;
  };

  const countFilters = (data, field, level) => {
    let counts = {};
    if (level === "service") {
      data.forEach(item => {
        const key = item[field];
        if (!key) return;
        counts[key] = (counts[key] || 0) + 1;
      });
      counts = updateOptions(field, counts);
    } else {
      data.forEach(entry => {
        const seen = new Set();
        (entry.datasets || []).forEach(ds => {
          const ms = ds[field];
          if (ms && !seen.has(ms)) {
            seen.add(ms);
            counts[ms] = (counts[ms] || 0) + 1;
          }
        });
        counts = updateOptions(field, counts);
      });
    }
    return Object.entries(counts);
  };

  const updateOptions = (field, options) => {
    const filter = MapConfig.Filters.find(a => a.filter === field);
    let orderedKeys = [];

    if (Array.isArray(filter?.labels) && filter.labels.length > 0) {
      const labelNames = filter.labels.map(label => label.name);

      orderedKeys = labelNames.filter(name => options.hasOwnProperty(name));

      const extraKeys = Object.keys(options)
        .filter(key => !labelNames.includes(key))
        .sort((a, b) => a.localeCompare(b));

      orderedKeys = [...orderedKeys, ...extraKeys];
    } else {
      orderedKeys = Object.keys(options).sort((a, b) => a.localeCompare(b));
    }


    orderedKeys.forEach(name => {
      if (!options.hasOwnProperty(name)) {
        options[name] = 0;
      }
    });

    const orderedOptions = {};
    orderedKeys.forEach(name => {
      orderedOptions[name] = options[name];
    });

    return orderedOptions;
  };

  const [data] = useState(getFilters());
  const [openFilters, setOpenFilters] = useState(() => {
    const filtersCount = getFilters().length;
    const initialOpenState = {};
    
    for (let i = 0; i < filtersCount; i++) {
      initialOpenState[i] = true;
    }
    
    return initialOpenState;
  });

  const toggleFilter = (index) => {
    setOpenFilters((prev) => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const handleCheckboxChange = (filterKey, label) => {
    setSelectedFilters(prev => {
      const group = prev[filterKey] ?? [];
      let updatedGroup;
      if (group.includes(label)) {
        updatedGroup = group.filter(item => item !== label);
      } else {
        updatedGroup = [...group, label];
      }
      return {
        ...prev,
        [filterKey]: updatedGroup.length ? updatedGroup : undefined
      };
    });
  };

  const clearFilters = () => {
    setSelectedFilters({});
    props.setFilters({});
    props.setShowFilter(false);
  };

  const applyFilters = () => {
    props.setFilters(selectedFilters);
    props.setShowFilter(false);
  };

  const isSelectedFiltersEmpty = () => {
    return !Object.values(selectedFilters).some(arr => arr && arr.length > 0);
  };

  return (
    <div className="widget-panel-overlay" ref={panelRef}>
      <div className="widget-title">
        Filters
        <button className="icon-button widget-close" onClick={() => {props.setShowFilter(false)}} aria-label="Close">
          <i className="fa-solid fa-xmark"></i>
        </button>
      </div>
      <div className="filter-container">
        {data.map((filter, i) => (
          <div className={"filter-item" + (openFilters[i] ? " expanded" : "")} key={i}>
            <div className="filter-header">
              {filter.title}
              <button className="icon-button" onClick={() => toggleFilter(i)} aria-label={openFilters[i] ? "Hide filter" : "Show filter"}>
                <i className="fa-solid fa-chevron-down"></i>
              </button>
            </div>
            <div className="filter-options">
              <div className="ccl-form">
                {filter.options.map(([label, count], ii) => (
                  <div className="filter-row" key={ii}>
                    <input
                      className="ccl-checkbox ccl-required ccl-form-check-input"
                      type="checkbox"
                      id={filter.filter + ii}
                      name={"filter_" + label}
                      value={label}
                      checked={selectedFilters[filter.filter]?.includes(label) ?? false}
                      onChange={() => handleCheckboxChange(filter.filter, label)}
                      disabled={count === 0}
                    />
                    <label className="ccl-form-check-label" htmlFor={filter.filter + ii}>
                      {MapConfig.Filters.find(a => a.filter === filter.filter)?.labels.find(a => a.name === label)?.label ?? label}
                    </label>
                    <span className="filter-count">{count}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
        <div className="filter-buttons">
          <button className="ccl-button ccl-button--default ccl-button--default-neg" disabled={isSelectedFiltersEmpty()} onClick={clearFilters} aria-label="Clear">
            Clear
          </button>
          <button className="ccl-button ccl-button--default" onClick={applyFilters} aria-label="Apply">
            Apply
          </button>
        </div>
    </div>
  );
}

export default FilterControl;
